export enum EIsoCode {
  PL = 'PL',
  EN = 'EN'
}

export enum ELanguage {
  Polish = 'Polski',
  English = 'English'
}

export interface TLanguage {
  active: number;
  current: number;
  link: string;
  locale: string;
  title: string;
  twoLetterIsoCode: string;
}
